import React, { FC } from 'react';
import { formatDate } from 'utils/format';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { DialogContent, Grid, Typography } from '@mui/material';
import { Restoration } from 'models/order';
import { currentUserVar } from 'apollo/reactive-variables/user';
import PriceSpec from '../price-specification/price-specification.component';

type CertifyDialogProps = {
    handleClose: () => void;
    currency: string;
    open: boolean;
    showUserAndDate?: boolean;
    restorations: Restoration[];
    handleConfirm: () => void;
};

const CertifyDialog: FC<CertifyDialogProps> = ({
    handleClose,
    open,
    currency,
    handleConfirm,
    restorations,
    showUserAndDate = false,
}: CertifyDialogProps) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    const currentUser = currentUserVar();

    return (
        <div>
            <Dialog
                open={open}
                maxWidth="lg"
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{translate('orders:CERTIFY_ORDER')}</DialogTitle>
                <DialogContent>
                    <PriceSpec restorations={restorations} currency={currency} />
                    {showUserAndDate ? (
                        <Grid container spacing={1} mt={0.5} p={1.25}>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="subtitle2">{translate('common:USER')}:</Typography>
                                {currentUser.name?.firstName} {currentUser.name?.lastName}
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="subtitle2">{translate('common:DATE')}:</Typography>
                                {formatDate(new Date(), 'datetime')}
                            </Grid>
                        </Grid>
                    ) : undefined}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{translate('CANCEL')}</Button>
                    <Button onClick={handleConfirm} variant="contained" autoFocus>
                        {translate('orders:CERTIFY_ORDER')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CertifyDialog;
